import React from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import * as ReactRedux from 'react-redux';
import getSuperScriptValue from 'SelfServeBuilderUtils';
import SectionItem from './SectionItem';

export class TextBoxSectionItem extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.doneEditingFieldPopups;
  }

  render() {
    const superscriptValue = getSuperScriptValue(
      this.props.fieldId,
      this.props.fieldData.label,
      this.props.popups,
    );
    const superscript = (superscriptValue > 0 && !this.props.isSample) ?
      <sup>{superscriptValue}</sup> :
    null;

    return (
      <SectionItem
        fieldId={this.props.fieldId}
        index={this.props.index}
      >
        <div className="section-item">
          <p className="text-box-section-item-label">
            {this.props.fieldData.label}{superscript}
          </p>
          <div className="section-item-preview" />
        </div>
      </SectionItem>
    );
  }
}

TextBoxSectionItem.defaultProps = {
  fieldData: {},
  isSample: false,
  popups: {},
};

TextBoxSectionItem.propTypes = {
  fieldData: PropTypes.shape({
    label: PropTypes.string,
  }),
  fieldId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isSample: PropTypes.bool,
  popups: CustomPropTypes.hashmapOf(
    PropTypes.shape({
      label: PropTypes.string,
    }),
  ),
};

const mapStateToProps = ({ SelfServeBuilderReducer }) => ({
  doneEditingFieldPopups: SelfServeBuilderReducer.popupCreationEnabled,
});

export default ReactRedux.connect(
  mapStateToProps,
)(TextBoxSectionItem);



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SectionOrganizer/TextBoxSectionItem.jsx